import { render, staticRenderFns } from "./AvgMonthlyCollectionsByIntroducerReport.vue?vue&type=template&id=57f72294&"
import script from "./AvgMonthlyCollectionsByIntroducerReport.vue?vue&type=script&lang=js&"
export * from "./AvgMonthlyCollectionsByIntroducerReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports